// import React, { useState, useEffect } from 'react';
// import { Search, Plus, Phone, PhoneCall, CheckCircle, HelpCircle, AlertTriangle, UserMinus, X, Eye, EyeOff, Loader2 } from 'lucide-react';

// export default function CRMEnquiryManagement() {
//   const [activeTab, setActiveTab] = useState('Lead');
//   const [leadsList, setLeadsList] = useState([]);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [tableLoading, setTableLoading] = useState(false);
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 5;

//   // Modal State Control Fields
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [formData, setFormData] = useState({
//     name: '', email: '', mobile: '', gender: 'Male', target_course: 'React FullStack', source_type: 'Walk-in', comment: ''
//   });

//   // MET Academy Domain Core Target Status Menu Config Array
//   const statusTabs = [
//     { id: 'Lead', name: 'New Leads', icon: HelpCircle },
//     { id: 'Interested', name: 'Interested', icon: CheckCircle },
//     { id: 'Call Back', name: 'Call Back', icon: PhoneCall },
//     { id: 'Not Interested', name: 'Not Interested', icon: UserMinus },
//     { id: 'Confirmed', name: 'Admission Confirmed', icon: CheckCircle },
//   ];

//   useEffect(() => {
//     fetchLeads();
//     setCurrentPage(1);
//   }, [activeTab, searchTerm]);

//   const fetchLeads = async () => {
//     setTableLoading(true);
//     try {
//       const res = await fetch(`https://metapi.emedhatechnologies.com/auth/api/api/crm?status=${encodeURIComponent(activeTab)}&search=${encodeURIComponent(searchTerm)}`);
//       const result = await res.json();
//       if (result.success) setLeadsList(result.data);
//     } catch (err) {
//       console.error("API transmission rejected:", err);
//     } finally {
//       setTableLoading(false);
//     }
//   };

//   const handleStatusChange = async (id, newStatus) => {
//     let cbDate = null;
//     let commentText = "Status modified via quick action controls.";
    
//     if (newStatus === 'Call Back') {
//       const datePrompt = prompt("Enter call back date & time (YYYY-MM-DD HH:MM):");
//       if (!datePrompt) return;
//       cbDate = datePrompt;
//       commentText = "Scheduled for call back.";
//     }

//     try {
//       const res = await fetch(`https://metapi.emedhatechnologies.com/auth/api/api/crm/status/${id}`, {
//         method: 'PATCH',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ status: newStatus, comment: commentText, date_of_callback: cbDate })
//       });
//       const result = await res.json();
//       if (result.success) fetchLeads();
//     } catch (err) {
//       console.error("Status modify transaction failure:", err);
//     }
//   };

//   const handleFormSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       const res = await fetch('https://metapi.emedhatechnologies.com/auth/api/api/crm', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(formData)
//       });
//       const result = await res.json();
//       if (result.success) {
//         setIsModalOpen(false);
//         fetchLeads();
//       }
//     } catch (err) {
//       console.error("Failed to post record:", err);
//     }
//   };

//   const totalPages = Math.ceil(leadsList.length / itemsPerPage) || 1;
//   const currentItems = leadsList.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

//   return (
//     <div>
//       {/* UPPER CONTROLS ACCESS LAYER */}
//       <div style={styles.topActionBar}>
//         {/* Dynamic Status Horizontal Scroll Menu Layout */}
//         <div style={styles.tabScrollGroup}>
//           {statusTabs.map((tab) => {
//             const TabIcon = tab.icon;
//             const isTabActive = activeTab === tab.id;
//             return (
//               <button
//                 key={tab.id}
//                 onClick={() => setActiveTab(tab.id)}
//                 style={{ ...styles.tabBtn, ...(isTabActive ? styles.tabBtnActive : {}) }}
//               >
//                 <TabIcon size={16} style={{ marginRight: '8px', color: isTabActive ? '#fff' : '#94a3b8' }} />
//                 {tab.name}
//               </button>
//             );
//           })}
//         </div>
        
//         <button onClick={() => setIsModalOpen(true)} style={styles.addNewLeadBtn}>
//           <Plus size={16} style={{ marginRight: '3px' }} /> ADD NEW LEAD
//         </button>
//       </div>

//       {/* SEARCH FILTERS CONTROLS SURFACE BAR */}
//       <div style={styles.filterControlPanel}>
//         <div style={styles.searchWrapper}>
//           <Search size={16} style={styles.searchIcon} />
//           <input 
//             type="text" 
//             placeholder={`Search ${activeTab} leads...`} 
//             value={searchTerm} 
//             onChange={(e) => setSearchTerm(e.target.value)} 
//             style={styles.tableSearchInput} 
//           />
//         </div>
//         <div style={styles.totalIndicator}>Total {activeTab} Leads : <strong style={{ color: '#459bf2' }}>{leadsList.length}</strong></div>
//       </div>

//       {/* CORE DATA TABLE MODULE COMPONENT CONTAINER */}
//       {tableLoading ? (
//         <div style={{ display: 'flex', justifyContent: 'center', padding: '50px' }}><Loader2 size={32} style={{ animation: 'spin 1s linear infinite' }} color="#459bf2" /></div>
//       ) : (
//         <div style={{ overflowX: 'auto' }}>
//           <table style={styles.dataTable}>
//             <thead>
//               <tr>
//                 <th style={styles.tableTh}>Name</th>
//                 <th style={styles.tableTh}>Email</th>
//                 <th style={styles.tableTh}>Mobile</th>
//                 <th style={styles.tableTh}>Course Intent</th>
//                 <th style={styles.tableTh}>Source</th>
//                 <th style={styles.tableTh}>Latest Comment</th>
//                 {activeTab === 'Call Back' && <th style={styles.tableTh}>Callback Target</th>}
//                 <th style={styles.tableTh}>Action Flow Routing</th>
//               </tr>
//             </thead>
//             <tbody>
//               {currentItems.map((lead) => (
//                 <tr key={lead.id} style={styles.tableTr}>
//                   <td style={{ ...styles.tableTd, fontWeight: '600', color: '#0f172a' }}>{lead.name}</td>
//                   <td style={styles.tableTd}>{lead.email}</td>
//                   <td style={styles.tableTd}>
//                     <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
//                       <a href={`tel:${lead.mobile}`} style={styles.phoneLinkCircle}><Phone size={12} /></a>
//                       {lead.mobile}
//                     </div>
//                   </td>
//                   <td style={styles.tableTd}><span style={styles.courseBadge}>{lead.target_course}</span></td>
//                   <td style={styles.tableTd}>{lead.source_type}</td>
//                   <td style={{ ...styles.tableTd, color: '#64748b', italic: 'true' }}>{lead.comment || 'No notes logged.'}</td>
//                   {activeTab === 'Call Back' && <td style={{ ...styles.tableTd, color: '#e30504', fontWeight: '600' }}>{lead.date_of_callback || 'Pending'}</td>}
//                   <td style={styles.tableTd}>
//                     <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
//                       {activeTab !== 'Interested' && <button onClick={() => handleStatusChange(lead.id, 'Interested')} style={styles.actIntBtn}>Interested</button>}
//                       {activeTab !== 'Call Back' && <button onClick={() => handleStatusChange(lead.id, 'Call Back')} style={styles.actCallBtn}>Call Back</button>}
//                       {activeTab !== 'Confirmed' && <button onClick={() => handleStatusChange(lead.id, 'Confirmed')} style={styles.actConfBtn}>Confirm Admission</button>}
//                       {activeTab !== 'Not Interested' && <button onClick={() => handleStatusChange(lead.id, 'Not Interested')} style={styles.actNotIntBtn}>Not Interested</button>}
//                     </div>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       )}

//       {/* PAGINATION LAYOUT WRAPPER ENGINE */}
//       <div style={styles.paginationBar}>
//         <span style={{ color: '#64748b', fontSize: '13px' }}>Page {currentPage} of {totalPages}</span>
//         <div style={{ display: 'flex', gap: '8px' }}>
//           <button disabled={currentPage === 1} onClick={() => setCurrentPage(currentPage - 1)} style={{ ...styles.pagBtn, ...(currentPage === 1 && styles.pagBtnDisabled) }}>Prev</button>
//           <button disabled={currentPage === totalPages} onClick={() => setCurrentPage(currentPage + 1)} style={{ ...styles.pagBtn, ...(currentPage === totalPages && styles.pagBtnDisabled) }}>Next</button>
//         </div>
//       </div>

//       {/* PROVISIONING INPUT MODAL PANEL */}
//       {isModalOpen && (
//         <div style={styles.modalBackdrop}>
//           <div style={styles.modalWrapperCard}>
//             <div style={styles.modalHeader}>
//               <h3 style={{ color: '#0f172a', margin: 0, fontWeight: 600 }}>Capture Fresh Candidate Enquiry</h3>
//               <button onClick={() => setIsModalOpen(false)} style={styles.modalCloseX}><X size={18} /></button>
//             </div>
            
//             <div style={styles.modalScrollBody}>
//               <form onSubmit={handleFormSubmit} style={styles.modalForm}>
//                 <div style={styles.formSplitGrid}>
//                   <div style={styles.fieldContainer}><label style={styles.fieldLabel}>Candidate Full Name</label><input type="text" required value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} style={styles.formInput} /></div>
//                   <div style={styles.fieldContainer}><label style={styles.fieldLabel}>Email Address</label><input type="email" required value={formData.email} onChange={(e) => setFormData({ ...formData, email: e.target.value })} style={styles.formInput} /></div>
//                   <div style={styles.fieldContainer}><label style={styles.fieldLabel}>Mobile Number</label><input type="text" required value={formData.mobile} onChange={(e) => setFormData({ ...formData, mobile: e.target.value })} style={styles.formInput} /></div>
//                   <div style={styles.fieldContainer}><label style={styles.fieldLabel}>Gender</label><select value={formData.gender} onChange={(e) => setFormData({ ...formData, gender: e.target.value })} style={styles.formSelect}><option>Male</option><option>Female</option></select></div>
//                   <div style={styles.fieldContainer}><label style={styles.fieldLabel}>Target Course Domain</label><select value={formData.target_course} onChange={(e) => setFormData({ ...formData, target_course: e.target.value })} style={styles.formSelect}><option>React FullStack</option><option>Data Science & AI</option><option>Cyber Security Master</option></select></div>
//                   <div style={styles.fieldContainer}><label style={styles.fieldLabel}>Lead Acquisition Source</label><select value={formData.source_type} onChange={(e) => setFormData({ ...formData, source_type: e.target.value })} style={styles.formSelect}><option>Walk-in</option><option>Website Form</option><option>Social Media Campaign</option></select></div>
//                 </div>
//                 <div style={styles.fieldContainer}><label style={styles.fieldLabel}>Counsellor Desk Remarks</label><textarea rows={3} value={formData.comment} onChange={(e) => setFormData({ ...formData, comment: e.target.value })} style={{ ...styles.formInput, resize: 'none' }} /></div>
                
//                 <div style={styles.formActionDock}>
//                   <button type="button" onClick={() => setIsModalOpen(false)} style={styles.formCancelBtn}>Cancel</button>
//                   <button type="submit" style={styles.formSaveBtn}>Submit</button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// // Master Luxury Light Theme Styles Specification Sheet Matrix Array Map
// const styles = {
//   topActionBar: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '16px', marginBottom: '20px', flexWrap: 'wrap' },
//   tabScrollGroup: { display: 'flex', gap: '8px', overflowX: 'auto', paddingBottom: '4px', maxWidth: '80vw' },
//   tabBtn: { display: 'inline-flex', alignItems: 'center', padding: '10px 16px', background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '10px', color: '#64748b', fontSize: '13.5px', fontWeight: '500', cursor: 'pointer', whiteSpace: 'nowrap', transition: 'all 0.2s ease' },
//   tabBtnActive: { background: 'linear-gradient(135deg, #459bf2 0%, #1c6ec9 100%)', borderColor: '#459bf2', color: '#ffffff', boxShadow: '0 4px 12px rgba(69, 155, 242, 0.2)' },
//   addNewLeadBtn: { background: 'linear-gradient(90deg, #e30504 0%, #a80302 100%)', border: 'none', borderRadius: '12px', color: '#fff', padding: '12px 20px', fontSize: '13px', fontWeight: '700', cursor: 'pointer', letterSpacing: '0.5px', boxShadow: '0 4px 12px rgba(227, 5, 4, 0.2)', marginBottom: '20px' },
//   filterControlPanel: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '16px', marginBottom: '20px', flexWrap: 'wrap', borderBottom: '1px solid #edf2f7', paddingBottom: '16px' },
//   searchWrapper: { position: 'relative', display: 'flex', alignItems: 'center', flex: 1, maxWidth: '340px', width: '100%' },
//   searchIcon: { position: 'absolute', left: '14px', color: '#94a3b8' },
//   tableSearchInput: { width: '100%', padding: '10px 14px 10px 40px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '10px', color: '#0f172a', fontSize: '14px', outline: 'none' },
//   totalIndicator: { fontSize: '15px', fontWeight: '600', color: '#334155' },
//   dataTable: { width: '100%', borderCollapse: 'collapse', textAlign: 'left' },
//   tableTh: { padding: '14px 16px', borderBottom: '2px solid #edf2f7', color: '#64748b', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.5px', fontWeight: '600' },
//   tableTr: { borderBottom: '1px solid #f1f5f9', transition: 'background 0.2s ease' },
//   tableTd: { padding: '14px 16px', color: '#475569', fontSize: '13.5px' },
//   phoneLinkCircle: { width: '24px', height: '24px', borderRadius: '50%', background: '#e0f2fe', color: '#0369a1', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', marginRight: '6px' },
//   courseBadge: { background: '#f0fdf4', border: '1px solid #bbf7d0', color: '#166534', padding: '4px 8px', borderRadius: '6px', fontSize: '12px', fontWeight: '500' },
  
//   // Dynamic Shading Actions Configuration Map
//   actIntBtn: { background: '#dcfce7', border: 'none', color: '#15803d', padding: '6px 10px', borderRadius: '6px', fontSize: '12px', fontWeight: '600', cursor: 'pointer' },
//   actCallBtn: { background: '#fef3c7', border: 'none', color: '#b45309', padding: '6px 10px', borderRadius: '6px', fontSize: '12px', fontWeight: '600', cursor: 'pointer' },
//   actConfBtn: { background: '#dbeafe', border: 'none', color: '#1d4ed8', padding: '6px 10px', borderRadius: '6px', fontSize: '12px', fontWeight: '600', cursor: 'pointer' },
//   actNotIntBtn: { background: '#fee2e2', border: 'none', color: '#b91c1c', padding: '6px 10px', borderRadius: '6px', fontSize: '12px', fontWeight: '600', cursor: 'pointer' },
  
//   paginationBar: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '20px' },
//   pagBtn: { background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '8px', color: '#475569', padding: '6px 14px', fontSize: '13px', cursor: 'pointer' },
//   pagBtnDisabled: { opacity: 0.4, cursor: 'not-allowed' },

//   // Overlay Architecture Viewport Configuration Properties
//   modalBackdrop: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(15, 23, 42, 0.25)', backdropFilter: 'blur(8px)', zIndex: 2000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' },
//   modalWrapperCard: { background: '#ffffff', border: '1px solid rgba(255,255,255,0.8)', borderRadius: '20px', width: '100%', maxWidth: '640px', maxHeight: '85vh', padding: '24px', boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.05)', display: 'flex', flexDirection: 'column', boxSizing: 'border-box' },
//   modalHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBottom: '14px', borderBottom: '1px solid #e2e8f0' },
//   modalCloseX: { background: 'transparent', border: 'none', color: '#94a3b8', cursor: 'pointer' },
//   modalScrollBody: { flex: 1, overflowY: 'auto', padding: '16px 4px 4px 4px' },
//   modalForm: { display: 'flex', flexDirection: 'column', gap: '16px' },
//   formSplitGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px' },
//   fieldContainer: { display: 'flex', flexDirection: 'column', gap: '4px' },
//   fieldLabel: { color: '#64748b', fontSize: '11px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px' },
//   formInput: { width: '100%', padding: '11px 12px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '8px', color: '#0f172a', fontSize: '13.5px', outline: 'none', boxSizing: 'border-box' },
//   formSelect: { padding: '11px 12px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '8px', color: '#0f172a', fontSize: '13.5px', outline: 'none' },
//   formActionDock: { display: 'flex', justifyContent: 'flex-end', gap: '12px', marginTop: '12px', borderTop: '1px solid #e2e8f0', paddingTop: '14px' },
//   formCancelBtn: { background: 'transparent', border: '1px solid #e2e8f0', color: '#64748b', padding: '10px 18px', borderRadius: '8px', cursor: 'pointer' },
//   formSaveBtn: { background: 'linear-gradient(90deg, #459bf2 0%, #1c6ec9 100%)', border: 'none', color: '#fff', padding: '10px 18px', borderRadius: '8px', fontWeight: '600', cursor: 'pointer' }
// };

import React, { useState, useEffect } from 'react';
import * as XLSX from 'xlsx';
import { Search, Plus, Phone, PhoneCall, CheckCircle, HelpCircle, UserMinus, X, Loader2, Clock, FileText, Upload, Download } from 'lucide-react';

export default function CRMEnquiryManagement() {
  // 1. Read live user data session trail straight from cache storage
  const sessionUser = JSON.parse(sessionStorage.getItem('userSession')) 

  const [activeTab, setActiveTab] = useState('Lead');
  const [leadsList, setLeadsList] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [tableLoading, setTableLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

const [universitiesList, setUniversitiesList] = useState([]); // ➕ Dynamic Universities State
  const [coursesList, setCoursesList] = useState([]); // ➕ Dynamic Courses State

  // Multi-Modal Conditional View State Triggers
  const [isNewLeadModalOpen, setIsNewLeadModalOpen] = useState(false);
  const [isTimelineModalOpen, setIsTimelineModalOpen] = useState(false);
  const [isAdmissionModalOpen, setIsAdmissionModalOpen] = useState(false);
  
  const [selectedLead, setSelectedLead] = useState(null);
  const [targetNextStatus, setTargetNextStatus] = useState('');


  const [isBulkModalOpen, setIsBulkModalOpen] = useState(false);
const [parsedLeads, setParsedLeads] = useState([]);
const [uploadingBulk, setUploadingBulk] = useState(false);


// ➕ Export & Filter States
const [exportFromDate, setExportFromDate] = useState('');
const [exportToDate, setExportToDate] = useState('');
const [exportCourse, setExportCourse] = useState('ALL');



  // Explicit Form Field Collections Maps
  const [newLeadFormData, setNewLeadFormData] = useState({
    name: '', email: '', mobile: '', alt_mobile: '', gender: 'Male', target_course: 'React FullStack', source_type: 'Walk-in', comment: ''
  });
  const [timelineFormData, setTimelineFormData] = useState({
    actionDateTime: '', comment: '', reason: 'Fees Too High'
  });

// Explicit Form Field Collections Maps (Batch Removed, Academic KYC Added)

// Updated frontend collection tracker values
const [admissionFormData, setAdmissionFormData] = useState({
  father_name: '',
  mother_name: '',
  dob: '',
  address: '',
  alt_mobile: '',
  target_courses: [], // Stores multi-selected course array
  course_ids: [],
  highest_qualification: 'XII',
  is_direct_admission: true,
  college_university: 'MET Academy Main Campus',
  university_adm_number: '',
  aadhar_number: '', 
  total_agreed_fees: '', 
  initial_deposit: '', 
  payment_mode: 'Online Transfer', 
  academic_year: '2026-2027', 
  guardian_name: '', 
  guardian_mobile: ''
});

  const statusTabs = [
    { id: 'Lead', name: 'New Leads', icon: HelpCircle },
    { id: 'Interested', name: 'Interested', icon: CheckCircle },
    { id: 'Call Back', name: 'Call Back', icon: PhoneCall },
    { id: 'Not Interested', name: 'Not Interested', icon: UserMinus },
    { id: 'Confirmed', name: 'Admission Confirmed', icon: CheckCircle },
  ];


  // A. Download sample Excel template
const downloadExcelTemplate = () => {
  const sampleData = [
    {
      "Name": "John Doe",
      "Email": "john@example.com",
      "Mobile": "9876543210",
      "Alt Mobile": "9123456780",
      "Gender": "Male",
      "Target Course": "B.Com",
      "Source": "Campaign",
      "Comment": "Interested in admissions"
    }
  ];

  const worksheet = XLSX.utils.json_to_sheet(sampleData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Leads_Template");
  XLSX.writeFile(workbook, "CRM_Leads_Import_Template.xlsx");
};



// ➕ Export filtered leads directly to Excel
const handleExportFilteredLeads = async () => {
  try {
    const params = new URLSearchParams({
      status: activeTab,
      fromDate: exportFromDate,
      toDate: exportToDate,
      course: exportCourse,
      userId: sessionUser?.id || '',
      userRole: sessionUser?.role || ''
    });

    const res = await fetch(`https://metapi.emedhatechnologies.com/crm/api/api/crm/export-leads?${params.toString()}`);
    const result = await res.json();

    if (!result.success || !result.data || result.data.length === 0) {
      alert("No leads found matching the selected filter criteria.");
      return;
    }

    // Format fields cleanly for spreadsheet presentation
    const exportFormattedData = result.data.map((lead, index) => ({
      "S.No": index + 1,
      // "Lead ID": `MET-LEAD-${lead.id}`,
      "Candidate Name": lead.name || 'N/A',
      "Email Address": lead.email || 'N/A',
      "Mobile Number": lead.mobile || 'N/A',
      "Alt Mobile": lead.alt_mobile || 'N/A',
      "Gender": lead.gender || 'N/A',
      "Target Course": lead.target_course || 'N/A',
      "Current Status": lead.status || 'Lead',
      "Lead Source": lead.source_type || 'N/A',
      "Counsellor Remarks": lead.comment || 'N/A',
      "Created By": `${lead.created_by_name || 'Staff'} (${lead.created_by_role || 'Staff'})`,
      "Created Date": lead.created_at ? new Date(lead.created_at).toLocaleDateString('en-IN') : 'N/A'
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportFormattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, `${activeTab}_Leads`);

    const fileName = `${activeTab}_Leads_${exportCourse !== 'ALL' ? exportCourse.replace(/[^a-zA-Z0-9]/g, '_') : 'AllCourses'}_${new Date().toISOString().substring(0, 10)}.xlsx`;
    XLSX.writeFile(workbook, fileName);
  } catch (err) {
    console.error("Export process failed:", err);
    alert("Failed to export leads. Please check your network connection.");
  }
};

// B. Parse uploaded file using XLSX
const handleExcelFileUpload = (e) => {
  const file = e.target.files[0];
  if (!file) return;

  const reader = new FileReader();
  reader.onload = (evt) => {
    try {
      const bstr = evt.target.result;
      const wb = XLSX.read(bstr, { type: 'binary' });
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      const data = XLSX.utils.sheet_to_json(ws);

      // Normalize column header keys
      const formatted = data.map((item) => ({
        name: item["Name"] || item["name"] || item["Candidate Name"] || '',
        email: item["Email"] || item["email"] || item["Email Address"] || '',
        mobile: item["Mobile"] || item["mobile"] || item["Mobile Number"] || item["Phone"] || '',
        alt_mobile: item["Alt Mobile"] || item["alt_mobile"] || item["Alternative Mobile"] || '',
        gender: item["Gender"] || item["gender"] || 'Male',
        target_course: item["Target Course"] || item["target_course"] || item["Course"] || 'General',
        source_type: item["Source"] || item["source_type"] || 'Excel Bulk Upload',
        comment: item["Comment"] || item["comment"] || 'Imported via Excel'
      })).filter(lead => lead.name && lead.mobile); // Must have Name and Mobile

      setParsedLeads(formatted);
    } catch (err) {
      console.error("Failed to parse Excel file:", err);
      alert("Failed to parse Excel file. Please use the standard template.");
    }
  };
  reader.readAsBinaryString(file);
};

// C. Submit parsed rows to backend
const handleBulkUploadSubmit = async () => {
  if (parsedLeads.length === 0) {
    alert("No valid lead records to upload.");
    return;
  }

  setUploadingBulk(true);
  try {
    const res = await fetch('https://metapi.emedhatechnologies.com/crm/api/api/crm/bulk-upload', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ leads: parsedLeads, sessionUser })
    });

    const result = await res.json();
    if (result.success) {
      alert(result.message);
      setIsBulkModalOpen(false);
      setParsedLeads([]);
      fetchLeads();
    } else {
      alert(result.message || "Failed to upload leads.");
    }
  } catch (err) {
    console.error("Bulk upload error:", err);
    alert("Network error occurred during bulk upload.");
  } finally {
    setUploadingBulk(false);
  }
};

  // ➕ Fetch dynamic courses from API
  useEffect(() => {
    const fetchCoursesList = async () => {
      try {
        const res = await fetch('https://metapi.emedhatechnologies.com/api/courses/courses');
        const data = await res.json();
        if (data.success && data.data.length > 0) {
          setCoursesList(data.data);
          // Set default target_course to the first course from API
          setNewLeadFormData((prev) => ({
            ...prev,
            target_course: data.data[0].course_name.trim(),
          }));
        }
      } catch (err) {
        console.error("Failed to load course options:", err);
      }
    };
    fetchCoursesList();
  }, []);


  // ➕ Fetch dynamic universities from API
useEffect(() => {
  const fetchUniversitiesList = async () => {
    try {
      const res = await fetch('https://metapi.emedhatechnologies.com/api/courses/universities?activeTab=universities');
      const data = await res.json();
      if (data.success && data.data.length > 0) {
        setUniversitiesList(data.data);
        // Set default campus location to the first university from API
        setAdmissionFormData((prev) => ({
          ...prev,
          college_university: data.data[0].university_name.trim(),
        }));
      }
    } catch (err) {
      console.error("Failed to load university campus options:", err);
    }
  };
  fetchUniversitiesList();
}, []);

  useEffect(() => {
    fetchLeads();
    setCurrentPage(1);
  }, [activeTab, searchTerm]);

  // 2. Fetch Leads with explicit context parameters for security visibility filtering
  const fetchLeads = async () => {
    setTableLoading(true);
    try {
      const res = await fetch(`https://metapi.emedhatechnologies.com/crm/api/api/crm?status=${encodeURIComponent(activeTab)}&search=${encodeURIComponent(searchTerm)}&userId=${sessionUser.id}&userRole=${sessionUser.role}`);
      const result = await res.json();
      if (result.success) setLeadsList(result.data);
    } catch (err) {
      console.error("API connection failed:", err);
    } finally {
      setTableLoading(false);
    }
  };

  const handleCreateLeadSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch('https://metapi.emedhatechnologies.com/crm/api/api/crm', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...newLeadFormData, sessionUser })
      });
      const result = await res.json();
      if (result.success) {
        setIsNewLeadModalOpen(false);
        setNewLeadFormData({ name: '', email: '', mobile: '', gender: 'Male', target_course: coursesList[0]?.course_name.trim() || '', source_type: 'Walk-in', comment: '' });
        fetchLeads();
      }
    } catch (err) {
      console.error("Failed to append lead:", err);
    }
  };

  const openTimelineModal = (lead, targetStatus) => {
    setSelectedLead(lead);
    setTargetNextStatus(targetStatus);
    setTimelineFormData({ actionDateTime: '', comment: '', reason: 'Fees Too High' });
    setIsTimelineModalOpen(true);
  };

  const handleTimelineSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch(`https://metapi.emedhatechnologies.com/crm/api/api/crm/update-timeline/${selectedLead.id}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          currentStatus: activeTab,
          newStatus: targetNextStatus,
          actionDateTime: timelineFormData.actionDateTime,
          comment: timelineFormData.comment,
          reason: targetNextStatus === 'Not Interested' ? timelineFormData.reason : null,
          sessionUser
        })
      });
      const result = await res.json();
      if (result.success) {
        setIsTimelineModalOpen(false);
        fetchLeads();
      }
    } catch (err) {
      console.error("Timeline push rejected:", err);
    }
  };


//   const openAdmissionModal = (lead) => {
//   setSelectedLead(lead);
//   setAdmissionFormData({ 
//     highest_qualification: 'XII',
//     is_direct_admission: true,
//     college_university: universitiesList[0]?.university_name.trim() || 'ALAGAPPA UNIVERSITY',
//     aadhar_number: '', 
//     total_agreed_fees: '', 
//     initial_deposit: '', 
//     payment_mode: 'Online Transfer', 
//     academic_year: '2026-2027', 
//     guardian_name: '', 
//     guardian_mobile: ''
//   });
//   setIsAdmissionModalOpen(true);
// };

const [courseSearchTerm, setCourseSearchQuery] = useState('');

// 2. Filter courses dynamically based on user typing
const filteredCourseOptions = coursesList.filter((course) =>
  course.course_name.toLowerCase().includes(courseSearchTerm.toLowerCase())
);

// const openAdmissionModal = (lead) => {
//   setSelectedLead(lead);
  
//   // Pre-select lead's primary target_course in array if available
//   const initialCourses = lead.target_course ? [lead.target_course.trim()] : [];

//   setAdmissionFormData({ 
//     father_name: '',
//     mother_name: '',
//     dob: '',
//     address: '',
//     alt_mobile: lead.alt_mobile || '',
//     target_courses: initialCourses,
//     highest_qualification: 'XII',
//     is_direct_admission: true,
//     college_university: universitiesList[0]?.university_name.trim() || 'ALAGAPPA UNIVERSITY',
//     university_adm_number: '',
//     aadhar_number: '', 
//     total_agreed_fees: '', 
//     initial_deposit: '', 
//     payment_mode: 'Online Transfer', 
//     academic_year: '2026-2027', 
//     guardian_name: '', 
//     guardian_mobile: ''
//   });
//   setIsAdmissionModalOpen(true);
// };

const openAdmissionModal = (lead) => {
  setSelectedLead(lead);

  // Match initial lead course with coursesList to get both name and id
  let initialCourses = [];
  let initialCourseIds = [];

  if (lead.target_course) {
    const matched = coursesList.find(
      (c) => c.course_name.trim().toLowerCase() === lead.target_course.trim().toLowerCase()
    );
    if (matched) {
      initialCourses = [matched.course_name.trim()];
      initialCourseIds = [matched.id];
    } else {
      initialCourses = [lead.target_course.trim()];
    }
  }

  setAdmissionFormData({ 
    father_name: '',
    mother_name: '',
    dob: '',
    address: '',
    alt_mobile: lead.alt_mobile || '',
    target_courses: initialCourses,
    course_ids: initialCourseIds, // ➕ Populated ID
    highest_qualification: 'XII',
    is_direct_admission: true,
    college_university: universitiesList[0]?.university_name.trim() || 'ALAGAPPA UNIVERSITY',
    university_adm_number: '',
    aadhar_number: '', 
    total_agreed_fees: '', 
    initial_deposit: '', 
    payment_mode: 'Online Transfer', 
    academic_year: '2026-2027', 
    guardian_name: '', 
    guardian_mobile: ''
  });
  setIsAdmissionModalOpen(true);
};


// const handleCourseSelectionToggle = (courseName) => {
//   setAdmissionFormData((prev) => {
//     const exists = prev.target_courses.includes(courseName);
//     const updatedCourses = exists
//       ? prev.target_courses.filter((c) => c !== courseName)
//       : [...prev.target_courses, courseName];
//     return { ...prev, target_courses: updatedCourses };
//   });
// };

const handleCourseSelectionToggle = (course) => {
  setAdmissionFormData((prev) => {
    const isChecked = prev.course_ids.includes(course.id);

    const updatedIds = isChecked
      ? prev.course_ids.filter((id) => id !== course.id)
      : [...prev.course_ids, course.id];

    const updatedNames = isChecked
      ? prev.target_courses.filter((name) => name !== course.course_name.trim())
      : [...prev.target_courses, course.course_name.trim()];

    return { 
      ...prev, 
      course_ids: updatedIds, 
      target_courses: updatedNames 
    };
  });
};

  // const handleAdmissionSubmit = async (e) => {
  //   e.preventDefault();
  //   try {
  //     const res = await fetch(`https://metapi.emedhatechnologies.com/crm/api/api/crm/finalize-admission/${selectedLead.id}`, {
  //       method: 'POST',
  //       headers: { 'Content-Type': 'application/json' },
  //       body: JSON.stringify({ ...admissionFormData, sessionUser })
  //     });
  //     const result = await res.json();
  //     if (result.success) {
  //       setIsAdmissionModalOpen(false);
  //       fetchLeads();
  //     }
  //   } catch (err) {
  //     console.error("Admission processing failure:", err);
  //   }
  // };

const handleAdmissionSubmit = async (e) => {
  e.preventDefault();
  console.log("🚀 [1/6] Form submission initiated");

  // 1. Clean and format the student's mobile number
  const rawMobileInput = selectedLead?.mobile || '';
  let rawMobile = String(rawMobileInput).replace(/\D/g, '');
  if (rawMobile.length === 10) {
    rawMobile = '91' + rawMobile;
  }
  console.log("📱 [2/6] Mobile Number Parsed:", { original: rawMobileInput, formatted: rawMobile });

  // 2. Format details for the confirmation message
  const targetCourses = admissionFormData.target_courses && admissionFormData.target_courses.length > 0 
    ? admissionFormData.target_courses.join(', ') 
    : (selectedLead?.target_course || 'Academic Program');

  const totalFee = Number(admissionFormData.total_agreed_fees) || 0;
  const depositPaid = Number(admissionFormData.initial_deposit) || 0;
  const pendingFee = totalFee - depositPaid;

  const messageBody = 
`🎓 *Admission Confirmation - MET Academy*

Dear *${selectedLead?.name || 'Candidate'}*,

Congratulations! Your admission paperwork has been officially processed and confirmed. Here are your onboarding details:

📋 *Candidate Name:* ${selectedLead?.name || 'N/A'}
🎓 *Selected Course(s):* ${targetCourses}
🏛️ *Campus / Center:* ${admissionFormData.college_university || 'Main Campus'}
${admissionFormData.university_adm_number ? `🔖 *Univ. Reg No:* ${admissionFormData.university_adm_number}\n` : ''}📅 *Academic Year:* ${admissionFormData.academic_year || 'N/A'}
💰 *Total Course Fee:* ₹${totalFee.toLocaleString('en-IN')}.00
💵 *Initial Deposit Paid:* ₹${depositPaid.toLocaleString('en-IN')}.00



Welcome to MET Academy! Your official student account is now active.

For any queries regarding your syllabus, schedule, or study materials, feel free to contact our administration desk.

Warm Regards,
*MET Academy Admissions Team*`;

  console.log("📝 [3/6] Formatted WhatsApp Body Prepared:", messageBody);

  // 3. Pre-create a hidden HTML anchor element synchronously
  let directLink = null;
  if (rawMobile && rawMobile.length >= 10) {
    const waUrl = `https://api.whatsapp.com/send?phone=${rawMobile}&text=${encodeURIComponent(messageBody)}`;
    directLink = document.createElement('a');
    directLink.href = waUrl;
    directLink.target = '_blank';
    directLink.rel = 'noopener noreferrer';
    document.body.appendChild(directLink);
    console.log("🔗 [4/6] Hidden anchor element mounted with URL:", waUrl);
  } else {
    console.warn("⚠️ Invalid or missing mobile number. WhatsApp link creation bypassed.");
  }

  // 4. Send admission payload to backend API
  try {
    console.log("📡 [5/6] Sending payload to API...", { leadId: selectedLead?.id, payload: admissionFormData });
    
    const res = await fetch(`https://metapi.emedhatechnologies.com/crm/api/api/crm/finalize-admission/${selectedLead.id}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ...admissionFormData, sessionUser })
    });

    const result = await res.json();
    console.log("📥 [6/6] Backend API Response:", result);

    if (result.success) {
      // 5. Trigger click if anchor was mounted
      if (directLink) {
        console.log("⚡ Executing programmatic click on WhatsApp link...");
        directLink.click();
        document.body.removeChild(directLink);
      } else {
        alert("Admission saved! Note: Student mobile number was missing or invalid for WhatsApp.");
      }

      setIsAdmissionModalOpen(false);
      fetchLeads();
    } else {
      if (directLink) document.body.removeChild(directLink);
      console.error("❌ API returned error status:", result.message);
      alert(result.message || "Failed to finalize admission paperwork.");
    }
  } catch (err) {
    if (directLink) document.body.removeChild(directLink);
    console.error("❌ Admission network/processing exception:", err);
    alert("Network error occurred while finalizing admission. Check console logs for details.");
  }
};


  const totalPages = Math.ceil(leadsList.length / itemsPerPage) || 1;
  const currentItems = leadsList.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  return (
    <div>
      {/* UPPER CONTROLS ACCESS LAYER */}
      <div style={styles.topActionBar}>
        <div style={styles.tabScrollGroup}>
          {statusTabs.map((tab) => {
            const TabIcon = tab.icon;
            const isTabActive = activeTab === tab.id;
            return (
              <button
                key={tab.id}
                onClick={() => { setActiveTab(tab.id); setCurrentPage(1); }}
                style={{ ...styles.tabBtn, ...(isTabActive ? styles.tabBtnActive : {}) }}
              >
                <TabIcon size={16} style={{ marginRight: '8px', color: isTabActive ? '#fff' : '#94a3b8' }} />
                {tab.name}
              </button>
            );
          })}
        </div>
      <div style={{ display: 'flex', gap: '8px', marginLeft: 'auto', alignItems: 'center' }}>
  <button 
    onClick={() => { setParsedLeads([]); setIsBulkModalOpen(true); }} 
    style={{ ...styles.addNewLeadBtn, background: 'linear-gradient(90deg, #10b981 0%, #059669 100%)', display: 'flex', alignItems: 'center', gap: '4px' }}
  >
    <Upload size={16} /> BULK UPLOAD EXCEL
  </button>
        <button onClick={() => setIsNewLeadModalOpen(true)} style={styles.addNewLeadBtn}>
          <Plus size={16} style={{ marginRight: '3px' }} /> ADD NEW LEAD
        </button>
      </div>
  </div>
      {/* SEARCH FILTERS CONTROLS SURFACE BAR */}
{/* ⚡ MODERN TWO-TIER FILTER & EXPORT DOCK */}
<div style={styles.filterDeckCard}>
  
  {/* Tier 1: Search Input & Lead Metrics */}
  <div style={styles.filterTopRow}>
    <div style={styles.searchWrapper}>
      <Search size={16} style={styles.searchIcon} />
      <input 
        type="text" 
        placeholder={`Search ${activeTab} leads by name, email, or mobile...`} 
        value={searchTerm} 
        onChange={(e) => setSearchTerm(e.target.value)} 
        style={styles.tableSearchInput} 
      />
    </div>

    <div style={styles.metricsBadge}>
      <span style={{ fontSize: '11px', color: '#64748b', textTransform: 'uppercase', fontWeight: '700' }}>Active Filter Count</span>
      <span style={{ fontSize: '15px', fontWeight: '800', color: '#1c6ec9' }}>{leadsList.length} <small style={{ fontSize: '11px', color: '#64748b', fontWeight: '500' }}>Leads</small></span>
    </div>
  </div>

  {/* Tier 2: Date Range, Course Selector, and Download Button */}
  <div style={styles.filterBottomRow}>
    
    <div style={styles.filterGroupWrapper}>
      {/* Date Pickers */}
      <div style={styles.inlineDateBox}>
        <div style={styles.filterInputBlock}>
          <span style={styles.filterMiniLabel}>From Date</span>
          <input 
            type="date" 
            value={exportFromDate} 
            onChange={(e) => setExportFromDate(e.target.value)} 
            style={styles.compactDateInput} 
          />
        </div>

        <span style={{ color: '#cbd5e1', fontWeight: '600', padding: '0 2px' }}>—</span>

        <div style={styles.filterInputBlock}>
          <span style={styles.filterMiniLabel}>To Date</span>
          <input 
            type="date" 
            value={exportToDate} 
            onChange={(e) => setExportToDate(e.target.value)} 
            style={styles.compactDateInput} 
          />
        </div>
      </div>

      {/* Course Filter Dropdown */}
      <div style={styles.filterInputBlock}>
        <span style={styles.filterMiniLabel}>Filter by Course Track</span>
        <select 
          value={exportCourse} 
          onChange={(e) => setExportCourse(e.target.value)} 
          style={styles.compactCourseSelect}
        >
          <option value="ALL">All Enrolled Courses</option>
          {coursesList.map((course) => (
            <option key={course.id} value={course.course_name.trim()}>
              {course.course_name.trim()}
            </option>
          ))}
        </select>
      </div>

      {/* Reset Filter Button (Shown only when filters are active) */}
      {(exportFromDate || exportToDate || exportCourse !== 'ALL') && (
        <button
          type="button"
          onClick={() => { setExportFromDate(''); setExportToDate(''); setExportCourse('ALL'); }}
          style={styles.resetFilterBtn}
        >
          Reset Filters
        </button>
      )}
    </div>

    {/* Export Excel Trigger Button */}
    <button 
      type="button" 
      onClick={handleExportFilteredLeads} 
      style={styles.exportExcelBtn}
      title="Export matching records to Excel spreadsheet"
    >
      <Download size={14} /> Export to Excel
    </button>

  </div>
</div>
        <div style={styles.totalIndicator}>Total {activeTab} Leads : <strong style={{ color: '#459bf2' }}>{leadsList.length}</strong></div>


      {/* CORE DATA TABLE MODULE COMPONENT CONTAINER */}
      {tableLoading ? (
        <div style={{ display: 'flex', justifyContent: 'center', padding: '50px' }}><Loader2 size={32} style={{ animation: 'spin 1s linear infinite' }} color="#459bf2" /></div>
      ) : (
        <div style={{ overflowX: 'auto' }}>
          <table style={styles.dataTable}>
            <thead>
              <tr>
                <th style={styles.tableTh}>Name</th>
                <th style={styles.tableTh}>Email</th>
                <th style={styles.tableTh}>Mobile</th>
                <th style={styles.tableTh}>Course Intent</th>
                <th style={styles.tableTh}>Source</th>
                <th style={styles.tableTh}>Created</th>
                <th style={styles.tableTh}>Comment</th>
                {activeTab === 'Call Back' && <th style={styles.tableTh}>Callback Target</th>}
                <th style={styles.tableTh}>Action</th>
              </tr>
            </thead>
            <tbody>
         {currentItems.map((lead) => (
                <tr key={lead.id} style={styles.tableTr}>
                  <td style={{ ...styles.tableTd, fontWeight: '600', color: '#0f172a' }}>{lead.name}</td>
                  <td style={styles.tableTd}>{lead.email}</td>
                  <td style={styles.tableTd}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px', whiteSpace: 'nowrap' }}>
                      <a href={`tel:${lead.mobile}`} style={styles.phoneLinkCircle}><Phone size={11} /></a>
                      {lead.mobile}
                    </div>
                  </td>
                  
                  {/* 📉 Course Intent with text-truncation limit wrapper */}
                  <td style={styles.tableTd}>
                    <div style={styles.truncatedText} title={lead.target_course}>
                      <span style={styles.courseBadge}>{lead.target_course}</span>
                    </div>
                  </td>
                  
                  <td style={styles.tableTd}>{lead.source_type}</td>
                  <td style={styles.tableTd}>
                    <strong style={{ fontSize: '11px', color: '#459bf2', textTransform: 'uppercase' }}>{lead.created_by_name}</strong>
                    <br/><span style={{ fontSize: '11px', color: '#94a3b8' }}>({lead.created_by_role})</span>
                  </td>
                  
                  {/* 📉 Lengthy comments safely restricted to single-line with ellipsis */}
                  <td style={styles.tableTd}>
                    <div style={styles.truncatedText} title={lead.comment || 'No notes logged.'}>
                      {lead.comment || 'No notes logged.'}
                    </div>
                  </td>
                  
                  {activeTab === 'Call Back' && <td style={{ ...styles.tableTd, color: '#e30504', fontWeight: '600', whiteSpace: 'nowrap' }}>{lead.date_of_callback || 'Pending'}</td>}
                  
                  {/* 📉 Adjusted ultra-compact button group */}
                  {/* <td style={styles.tableTd}>
                    <div style={styles.actionBtnContainer}>
                      {activeTab !== 'Interested' && <button onClick={() => openTimelineModal(lead, 'Interested')} style={styles.actIntBtn}>Interested</button>}
                      {activeTab !== 'Call Back' && <button onClick={() => openTimelineModal(lead, 'Call Back')} style={styles.actCallBtn}>Callback</button>}
                      {activeTab !== 'Confirmed' && <button onClick={() => openAdmissionModal(lead)} style={styles.actConfBtn}>Confirm Admission</button>}
                      {activeTab !== 'Not Interested' && <button onClick={() => openTimelineModal(lead, 'Not Interested')} style={styles.actNotIntBtn}>Not Interested</button>}
                    </div>
                  </td> */}
                  {/* 💻 UPDATED: Dynamic Action Flow Mapping */}
                  <td style={styles.tableTd}>
                    <div style={styles.actionBtnContainer}>
                      {activeTab === 'Confirmed' ? (
                        <>
                          {/* Post-Admission Actions */}
                          <button 
                            onClick={() => {
                              setSelectedLead(lead);
                              // We will look up the extra details from student_admissions or state mapping
                              alert(`Reviewing Profile: ${lead.name}\nCourse: ${lead.target_course}\nStatus: Enrolled`);
                            }} 
                            style={styles.actConfBtn}
                          >
                            View Details
                          </button>
                          <span style={{ fontSize: '12px', color: '#10b981', fontWeight: '600', marginLeft: '4px' }}>
                            ✓ Registered
                          </span>
                        </>
                      ) : (
                        /* Standard Pre-Admission CRM Actions */
                        <>
                          {activeTab !== 'Interested' && <button onClick={() => openTimelineModal(lead, 'Interested')} style={styles.actIntBtn}>Interested</button>}
                          {activeTab !== 'Call Back' && <button onClick={() => openTimelineModal(lead, 'Call Back')} style={styles.actCallBtn}>Callback</button>}
                          {activeTab !== 'Confirmed' && <button onClick={() => openAdmissionModal(lead)} style={styles.actConfBtn}>Confirm Admission</button>}
                          {activeTab !== 'Not Interested' && <button onClick={() => openTimelineModal(lead, 'Not Interested')} style={styles.actNotIntBtn}>Not Interested</button>}
                        </>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* PAGINATION LAYOUT WRAPPER ENGINE */}
      <div style={styles.paginationBar}>
        <span style={{ color: '#64748b', fontSize: '13px' }}>Page {currentPage} of {totalPages}</span>
        <div style={{ display: 'flex', gap: '8px' }}>
          <button disabled={currentPage === 1} onClick={() => setCurrentPage(currentPage - 1)} style={{ ...styles.pagBtn, ...(currentPage === 1 && styles.pagBtnDisabled) }}>Prev</button>
          <button disabled={currentPage === totalPages} onClick={() => setCurrentPage(currentPage + 1)} style={{ ...styles.pagBtn, ...(currentPage === totalPages && styles.pagBtnDisabled) }}>Next</button>
        </div>
      </div>

      {/* MODAL 1: ADD FRESH LEAD POPUP */}
      {/* {isNewLeadModalOpen && (
        <div style={styles.modalBackdrop}>
          <div style={styles.modalWrapperCard}>
            <div style={styles.modalHeader}>
              <h3 style={{ color: '#0f172a', margin: 0, fontWeight: 600 }}>Capture Fresh Candidate Enquiry</h3>
              <button onClick={() => setIsNewLeadModalOpen(false)} style={styles.modalCloseX}><X size={18} /></button>
            </div>
            <div style={styles.modalScrollBody}>
              <form onSubmit={handleCreateLeadSubmit} style={styles.modalForm}>
                <div style={styles.formSplitGrid}>
                  <div style={styles.fieldContainer}><label style={styles.fieldLabel}>Candidate Full Name</label><input type="text" required value={newLeadFormData.name} onChange={(e) => setNewLeadFormData({ ...newLeadFormData, name: e.target.value })} style={styles.formInput} /></div>
                  <div style={styles.fieldContainer}><label style={styles.fieldLabel}>Email Address</label><input type="email" required value={newLeadFormData.email} onChange={(e) => setNewLeadFormData({ ...newLeadFormData, email: e.target.value })} style={styles.formInput} /></div>
                  <div style={styles.fieldContainer}><label style={styles.fieldLabel}>Mobile Number</label><input type="text" required value={newLeadFormData.mobile} onChange={(e) => setNewLeadFormData({ ...newLeadFormData, mobile: e.target.value })} style={styles.formInput} /></div>
                  <div style={styles.fieldContainer}><label style={styles.fieldLabel}>Gender</label><select value={newLeadFormData.gender} onChange={(e) => setNewLeadFormData({ ...newLeadFormData, gender: e.target.value })} style={styles.formSelect}><option>Male</option><option>Female</option></select></div>
                <div style={styles.fieldContainer}>
  <label style={styles.fieldLabel}>Target Course Domain</label>
  <select 
    value={newLeadFormData.target_course} 
    onChange={(e) => setNewLeadFormData({ ...newLeadFormData, target_course: e.target.value })} 
    style={styles.formSelect}
  >
    {coursesList.length === 0 ? (
      <option value="">Loading courses...</option>
    ) : (
      coursesList.map((course) => (
        <option key={course.id} value={course.course_name.trim()}>
          {course.course_name.trim()}
        </option>
      ))
    )}
  </select>
</div>
                  <div style={styles.fieldContainer}><label style={styles.fieldLabel}>Lead Acquisition Source</label><select value={newLeadFormData.source_type} onChange={(e) => setNewLeadFormData({ ...newLeadFormData, source_type: e.target.value })} style={styles.formSelect}><option>Walk-in</option><option>Website Form</option><option>Social Media Campaign</option></select></div>
                </div>
                <div style={styles.fieldContainer}><label style={styles.fieldLabel}>Counsellor Desk Remarks</label><textarea rows={3} value={newLeadFormData.comment} onChange={(e) => setNewLeadFormData({ ...newLeadFormData, comment: e.target.value })} style={{ ...styles.formInput, resize: 'none' }} /></div>
                <div style={styles.formActionDock}>
                  <button type="button" onClick={() => setIsNewLeadModalOpen(false)} style={styles.formCancelBtn}>Cancel</button>
                  <button type="submit" style={styles.formSaveBtn}>Submit</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )} */}

      {/* MODAL 1: ADD FRESH LEAD POPUP */}
{isNewLeadModalOpen && (
  <div style={styles.modalBackdrop}>
    <div style={styles.modalWrapperCard}>
      <div style={styles.modalHeader}>
        <h3 style={{ color: '#0f172a', margin: 0, fontWeight: 600 }}>Capture Fresh Candidate Enquiry</h3>
        <button onClick={() => setIsNewLeadModalOpen(false)} style={styles.modalCloseX}><X size={18} /></button>
      </div>
      <div style={styles.modalScrollBody}>
        <form onSubmit={handleCreateLeadSubmit} style={styles.modalForm}>
          
          {/* ⚡ 2-COLUMN BALANCED GRID FOR FIRST 6 INPUTS */}
          <div style={styles.formSplitGrid}>
            <div style={styles.fieldContainer}>
              <label style={styles.fieldLabel}>Candidate Full Name</label>
              <input type="text" required value={newLeadFormData.name} onChange={(e) => setNewLeadFormData({ ...newLeadFormData, name: e.target.value })} style={styles.formInput} />
            </div>

            <div style={styles.fieldContainer}>
              <label style={styles.fieldLabel}>Email Address</label>
              <input type="email" required value={newLeadFormData.email} onChange={(e) => setNewLeadFormData({ ...newLeadFormData, email: e.target.value })} style={styles.formInput} />
            </div>

            <div style={styles.fieldContainer}>
              <label style={styles.fieldLabel}>Mobile Number</label>
              <input type="text" required value={newLeadFormData.mobile} onChange={(e) => setNewLeadFormData({ ...newLeadFormData, mobile: e.target.value })} style={styles.formInput} />
            </div>

<div style={styles.fieldContainer}>
  <label style={styles.fieldLabel}>Alternative Mobile (Optional)</label>
  <input 
    type="text" 
    placeholder="e.g. WhatsApp or Secondary No."
    value={newLeadFormData.alt_mobile} 
    onChange={(e) => setNewLeadFormData({ ...newLeadFormData, alt_mobile: e.target.value })} 
    style={styles.formInput} 
  />
</div>
            <div style={styles.fieldContainer}>
              <label style={styles.fieldLabel}>Gender</label>
              <select value={newLeadFormData.gender} onChange={(e) => setNewLeadFormData({ ...newLeadFormData, gender: e.target.value })} style={styles.formSelect}>
                <option>Male</option>
                <option>Female</option>
                  <option value="Transgender">Transgender</option>
              </select>
            </div>

            <div style={styles.fieldContainer}>
              <label style={styles.fieldLabel}>Target Course Domain</label>
              <select 
                value={newLeadFormData.target_course} 
                onChange={(e) => setNewLeadFormData({ ...newLeadFormData, target_course: e.target.value })} 
                style={styles.formSelect}
              >
                {coursesList.length === 0 ? (
                  <option value="">Loading courses...</option>
                ) : (
                  coursesList.map((course) => (
                    <option key={course.id} value={course.course_name.trim()}>
                      {course.course_name.trim()}
                    </option>
                  ))
                )}
              </select>
            </div>

            <div style={styles.fieldContainer}>
              <label style={styles.fieldLabel}>Lead Acquisition Source</label>
              <select value={newLeadFormData.source_type} onChange={(e) => setNewLeadFormData({ ...newLeadFormData, source_type: e.target.value })} style={styles.formSelect}>
                <option>Walk-in</option>
                <option>Website Form</option>
                <option>Social Media Campaign</option>
              </select>
            </div>
          </div>

          {/* ⚡ FULL-WIDTH COUNSELLOR DESK REMARKS */}
          <div style={styles.fieldContainer}>
            <label style={styles.fieldLabel}>Counsellor Desk Remarks</label>
            <textarea rows={3} value={newLeadFormData.comment} onChange={(e) => setNewLeadFormData({ ...newLeadFormData, comment: e.target.value })} style={{ ...styles.formInput, resize: 'none' }} />
          </div>

          <div style={styles.formActionDock}>
            <button type="button" onClick={() => setIsNewLeadModalOpen(false)} style={styles.formCancelBtn}>Cancel</button>
            <button type="submit" style={styles.formSaveBtn}>Submit</button>
          </div>
        </form>
      </div>
    </div>
  </div>
)}

      {/* MODAL 2: INTERACTIVE FOLLOW-UP STATE TRANSITIONS TIMELINE MODAL */}
      {isTimelineModalOpen && (
        <div style={styles.modalBackdrop}>
          <div style={styles.modalWrapperCard}>
            <div style={styles.modalHeader}>
              <h3 style={{ color: '#0f172a', margin: 0, fontWeight: 600 }}>Log Follow-Up Step: {targetNextStatus}</h3>
              <button onClick={() => setIsTimelineModalOpen(false)} style={styles.modalCloseX}><X size={18} /></button>
            </div>
            <div style={styles.modalScrollBody}>
              <form onSubmit={handleTimelineSubmit} style={styles.modalForm}>
                {(targetNextStatus === 'Call Back' || targetNextStatus === 'Interested') && (
                  <div style={styles.fieldContainer}>
                    <label style={styles.fieldLabel}><Clock size={12} /> Targeted Action Date & Time</label>
                    <input type="datetime-local" required value={timelineFormData.actionDateTime} onChange={(e) => setTimelineFormData({ ...timelineFormData, actionDateTime: e.target.value })} style={styles.formInput} />
                  </div>
                )}
                {targetNextStatus === 'Not Interested' && (
                  <div style={styles.fieldContainer}>
                    <label style={styles.fieldLabel}>Rejection Classification Reason</label>
                    <select value={timelineFormData.reason} onChange={(e) => setTimelineFormData({ ...timelineFormData, reason: e.target.value })} style={styles.formSelect}>
                      <option value="Fees Too High">Fees Too High</option>
                      <option value="Joined Elsewhere">Joined Elsewhere</option>
                      <option value="Location Distance">Distance / Location Issue</option>
                      <option value="Timing Conflict">Timing Conflict</option>
                    </select>
                  </div>
                )}
                <div style={styles.fieldContainer}>
                  <label style={styles.fieldLabel}>Staff Discussion Notes Summary</label>
                  <textarea rows={3} required value={timelineFormData.comment} onChange={(e) => setTimelineFormData({ ...timelineFormData, comment: e.target.value })} style={{ ...styles.formInput, resize: 'none' }} placeholder="Provide insights from contact discussion..." />
                </div>
                <div style={styles.formActionDock}>
                  <button type="button" onClick={() => setIsTimelineModalOpen(false)} style={styles.formCancelBtn}>Cancel</button>
                  <button type="submit" style={styles.formSaveBtn}>Record Progression Step</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* MODAL 3: LUXURIOUS ACADEMIC ADMISSION FINALIZATION WINDOW */}
 {/* MODAL 3: LUXURIOUS ACADEMIC ADMISSION FINALIZATION WINDOW */}
      {isAdmissionModalOpen && (
        <div style={styles.modalBackdrop}>
          <div style={styles.modalWrapperCard}>
            <div style={styles.modalHeader}>
              <h3 style={{ color: '#0f172a', margin: 0, fontWeight: 600 }}><FileText size={18} style={{ marginRight: '6px', color: '#459bf2' }} /> File Onboarding Admission Paperwork</h3>
              <button onClick={() => setIsAdmissionModalOpen(false)} style={styles.modalCloseX}><X size={18} /></button>
            </div>
            <div style={styles.modalScrollBody}>
              <form onSubmit={handleAdmissionSubmit} style={styles.modalForm}>
              <div style={styles.formSplitGrid}>
  <div style={styles.fieldContainer}>
    <label style={styles.fieldLabel}>Primary Contact Mobile</label>
    <input 
      type="text" 
      disabled 
      value={selectedLead?.mobile || ''} 
      style={{ ...styles.formInput, background: '#f1f5f9', color: '#64748b' }} 
    />
  </div>

  {/* ➕ Optional Alternative Mobile for Admission */}
  <div style={styles.fieldContainer}>
    <label style={styles.fieldLabel}>Alternative Mobile Number (Optional)</label>
    <input 
      type="text" 
      placeholder="Optional Contact No."
      value={admissionFormData.alt_mobile} 
      onChange={(e) => setAdmissionFormData({ ...admissionFormData, alt_mobile: e.target.value })} 
      style={styles.formInput} 
    />
  </div>
</div>
                <div style={styles.formSplitGrid}>
                  <div style={styles.fieldContainer}>
                    <label style={styles.fieldLabel}>Highest Qualification</label>
                    <select value={admissionFormData.highest_qualification} onChange={(e) => setAdmissionFormData({ ...admissionFormData, highest_qualification: e.target.value })} style={styles.formSelect}>
                      <option value="X">Class X</option>
                      <option value="XII">Class XII</option>
                      <option value="Graduate">Undergraduate Degree</option>
                    </select>
                  </div>
                  <div style={styles.fieldContainer}>
                    <label style={styles.fieldLabel}>Admission Route Type</label>
                    <select value={admissionFormData.is_direct_admission} onChange={(e) => setAdmissionFormData({ ...admissionFormData, is_direct_admission: e.target.value === 'true' })} style={styles.formSelect}>
                      <option value="true">Direct Admission</option>
                      <option value="false">Counselling / Entrance</option>
                    </select>
                  </div>
             
              <div style={styles.fieldContainer}>
  <label style={styles.fieldLabel}>Select Target Campus Location</label>
  <select 
    value={admissionFormData.college_university} 
    onChange={(e) => setAdmissionFormData({ ...admissionFormData, college_university: e.target.value })} 
    style={styles.formSelect}
  >
    {universitiesList.length === 0 ? (
      <option value="">Loading campus locations...</option>
    ) : (
      universitiesList.map((uni) => (
        <option key={uni.id} value={uni.university_name.trim()}>
          {uni.university_name.trim()}
        </option>
      ))
    )}
  </select>
</div>

<div style={styles.fieldContainer}>
    <label style={styles.fieldLabel}>University Admission / Reg. No</label>
    <input 
      type="text" 
      placeholder="e.g. AU-2026-REG-0145" 
      value={admissionFormData.university_adm_number} 
      onChange={(e) => setAdmissionFormData({ ...admissionFormData, university_adm_number: e.target.value })} 
      style={styles.formInput} 
    />
  </div>



                  <div style={styles.fieldContainer}><label style={styles.fieldLabel}>Academic Year Framework</label><input type="text" value={admissionFormData.academic_year} onChange={(e) => setAdmissionFormData({ ...admissionFormData, academic_year: e.target.value })} style={styles.formInput} /></div>
                  <div style={styles.fieldContainer}><label style={styles.fieldLabel}>Total Agreed Fees</label><input type="number" required value={admissionFormData.total_agreed_fees} onChange={(e) => setAdmissionFormData({ ...admissionFormData, total_agreed_fees: e.target.value })} style={styles.formInput} /></div>
                  <div style={styles.fieldContainer}><label style={styles.fieldLabel}>Initial Deposit Paid</label><input type="number" required value={admissionFormData.initial_deposit} onChange={(e) => setAdmissionFormData({ ...admissionFormData, initial_deposit: e.target.value })} style={styles.formInput} /></div>
                  <div style={styles.fieldContainer}>
                    <label style={styles.fieldLabel}>Payment Mode</label>
                    <select value={admissionFormData.payment_mode} onChange={(e) => setAdmissionFormData({ ...admissionFormData, payment_mode: e.target.value })} style={styles.formSelect}>
                      <option>Online Transfer</option>
                      <option>Cash Desk</option>
                    </select>
                  </div>
                  <div style={styles.fieldContainer}><label style={styles.fieldLabel}>Parent / Guardian Full Name</label><input type="text" value={admissionFormData.guardian_name} onChange={(e) => setAdmissionFormData({ ...admissionFormData, guardian_name: e.target.value })} style={styles.formInput} /></div>
                  <div style={styles.fieldContainer}><label style={styles.fieldLabel}>Guardian Contact Mobile</label><input type="text" value={admissionFormData.guardian_mobile} onChange={(e) => setAdmissionFormData({ ...admissionFormData, guardian_mobile: e.target.value })} style={styles.formInput} /></div>
                </div>


                {/* Personal & Family Details Grid */}
<div style={styles.formSplitGrid}>
  <div style={styles.fieldContainer}>
    <label style={styles.fieldLabel}>Father Name</label>
    <input 
      type="text" 
      required
      placeholder="Enter Father Name"
      value={admissionFormData.father_name} 
      onChange={(e) => setAdmissionFormData({ ...admissionFormData, father_name: e.target.value })} 
      style={styles.formInput} 
    />
  </div>

  <div style={styles.fieldContainer}>
    <label style={styles.fieldLabel}>Mother Name</label>
    <input 
      type="text" 
      required
      placeholder="Enter Mother Name"
      value={admissionFormData.mother_name} 
      onChange={(e) => setAdmissionFormData({ ...admissionFormData, mother_name: e.target.value })} 
      style={styles.formInput} 
    />
  </div>
</div>

<div style={styles.formSplitGrid}>
  <div style={styles.fieldContainer}>
    <label style={styles.fieldLabel}>Date of Birth</label>
    <input 
      type="date" 
      required
      value={admissionFormData.dob} 
      onChange={(e) => setAdmissionFormData({ ...admissionFormData, dob: e.target.value })} 
      style={styles.formInput} 
    />
  </div>

  <div style={styles.fieldContainer}>
    <label style={styles.fieldLabel}>Residential Address</label>
    <input 
      type="text" 
      required
      placeholder="Full Communication Address"
      value={admissionFormData.address} 
      onChange={(e) => setAdmissionFormData({ ...admissionFormData, address: e.target.value })} 
      style={styles.formInput} 
    />
  </div>
</div>

{/* Multi-Course Selection Checklist Box */}
{/* Multi-Course Selection Checklist Box */}
<div style={{ background: '#f8fafc', padding: '12px', borderRadius: '8px', border: '1px solid #e2e8f0', marginTop: '6px' }}>
  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
    <label style={{ ...styles.fieldLabel, color: '#1c6ec9', margin: 0 }}>
      Select Target Courses ({admissionFormData.target_courses.length} Selected)
    </label>
    {admissionFormData.target_courses.length > 0 && (
      <button 
        type="button" 
        onClick={() => setAdmissionFormData(prev => ({ ...prev, target_courses: [], course_ids: [] }))}
        style={{ background: 'transparent', border: 'none', color: '#e30504', fontSize: '11px', fontWeight: '600', cursor: 'pointer' }}
      >
        Clear All
      </button>
    )}
  </div>

  {/* Active Selected Course Chips */}
  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginBottom: '10px' }}>
    {admissionFormData.target_courses.length === 0 ? (
      <span style={{ fontSize: '11.5px', color: '#94a3b8', fontStyle: 'italic' }}>No courses selected yet. Choose from list below:</span>
    ) : (
      admissionFormData.target_courses.map((selectedName) => {
        const matchedCourse = coursesList.find(c => c.course_name.trim() === selectedName);
        return (
          <span 
            key={selectedName} 
            style={{
              background: '#eff6ff',
              border: '1px solid #bfdbfe',
              color: '#1e40af',
              padding: '3px 8px',
              borderRadius: '12px',
              fontSize: '11.5px',
              fontWeight: '600',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '4px'
            }}
          >
            {selectedName} {matchedCourse?.course_medium ? `(${matchedCourse.course_medium})` : ''}
            <button
              type="button"
              onClick={() => {
                if (matchedCourse) {
                  handleCourseSelectionToggle(matchedCourse);
                } else {
                  setAdmissionFormData(prev => ({
                    ...prev,
                    target_courses: prev.target_courses.filter(n => n !== selectedName)
                  }));
                }
              }}
              style={{ background: 'transparent', border: 'none', color: '#1e40af', cursor: 'pointer', padding: 0, display: 'flex', alignItems: 'center' }}
            >
              <X size={12} />
            </button>
          </span>
        );
      })
    )}
  </div>

  {/* Search Bar Input */}
  <div style={{ position: 'relative', marginBottom: '8px' }}>
    <Search size={14} style={{ position: 'absolute', left: '10px', top: '9px', color: '#94a3b8' }} />
    <input
      type="text"
      placeholder="Search course titles or medium..."
      value={courseSearchTerm}
      onChange={(e) => setCourseSearchQuery(e.target.value)}
      style={{ ...styles.formInput, padding: '7px 10px 7px 32px', fontSize: '12px' }}
    />
  </div>

  {/* Inner Scrollable List displaying Code, Medium & Name */}
  <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', maxHeight: '140px', overflowY: 'auto', paddingRight: '4px' }}>
    {coursesList
      .filter(c => 
        c.course_name.toLowerCase().includes(courseSearchTerm.toLowerCase()) ||
        (c.course_medium && c.course_medium.toLowerCase().includes(courseSearchTerm.toLowerCase())) ||
        (c.course_code && String(c.course_code).toLowerCase().includes(courseSearchTerm.toLowerCase()))
      )
      .map((course) => {
        const isChecked = admissionFormData.course_ids.includes(course.id);
        return (
          <label
            key={course.id}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '6px 10px',
              borderRadius: '6px',
              cursor: 'pointer',
              border: isChecked ? '1px solid #bfdbfe' : '1px solid #e2e8f0',
              background: isChecked ? '#eff6ff' : '#ffffff',
              transition: 'all 0.15s ease'
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flex: 1, minWidth: 0 }}>
              <input
                type="checkbox"
                checked={isChecked}
                onChange={() => handleCourseSelectionToggle(course)}
              />
              <span style={{ fontSize: '12.5px', fontWeight: isChecked ? '600' : '400', color: isChecked ? '#1e40af' : '#334155', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {course.course_name}
              </span>
            </div>

            {/* Course Medium & Code Badges */}
            <div style={{ display: 'flex', gap: '4px', flexShrink: 0, marginLeft: '8px' }}>
              <span style={{ fontSize: '10px', background: '#f1f5f9', color: '#475569', padding: '2px 6px', borderRadius: '4px', fontWeight: '600' }}>
                {course.course_medium}
              </span>
              <span style={{ fontSize: '10px', background: '#e0f2fe', color: '#0369a1', padding: '2px 6px', borderRadius: '4px', fontWeight: '700' }}>
                #{course.course_code}
              </span>
            </div>
          </label>
        );
      })}
  </div>
</div>
                {/* Secure Identity Verification Checkbox (Generic Redacted Placeholder Flow) */}
           {/* <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '14px', marginTop: '4px' }}>
                  <div style={styles.fieldContainer}>
                    <label style={styles.fieldLabel}>Aadhaar Card Number (KYC Verification)</label>
                    <input 
                      type="text" 
                      required 
                      placeholder="Enter 12-Digit Aadhaar Identification Number" 
                      maxLength={14}
                      value={admissionFormData.aadhar_number} 
                      onChange={(e) => setAdmissionFormData({ ...admissionFormData, aadhar_number: e.target.value })} 
                      style={styles.formInput} 
                    />
                  </div>
                </div> */}

                <div style={styles.formActionDock}>
                  <button type="button" onClick={() => setIsAdmissionModalOpen(false)} style={styles.formCancelBtn}>Cancel</button>
                  <button type="submit" style={{ ...styles.formSaveBtn, background: 'linear-gradient(90deg, #10b981 0%, #059669 100%)' }}>Submit</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* MODAL 4: BULK EXCEL UPLOAD MODAL */}
{isBulkModalOpen && (
  <div style={styles.modalBackdrop}>
    <div style={{ ...styles.modalWrapperCard, maxWidth: '620px' }}>
      <div style={styles.modalHeader}>
        <h3 style={{ color: '#0f172a', margin: 0, fontWeight: 600, display: 'flex', alignItems: 'center', gap: '6px' }}>
          <Upload size={18} color="#10b981" /> Bulk Upload Leads from Excel
        </h3>
        <button onClick={() => setIsBulkModalOpen(false)} style={styles.modalCloseX}><X size={18} /></button>
      </div>

      <div style={{ padding: '16px 4px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
        
        {/* Template Download strip */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px', background: '#f8fafc', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
          <div>
            <strong style={{ fontSize: '13px', color: '#334155', display: 'block' }}>Download Sample Template</strong>
            <span style={{ fontSize: '11.5px', color: '#64748b' }}>Includes columns: Name, Email, Mobile, Alt Mobile, Gender, Target Course</span>
          </div>
          <button 
            type="button" 
            onClick={downloadExcelTemplate} 
            style={{ background: '#eff6ff', border: '1px solid #bfdbfe', color: '#1e40af', padding: '6px 12px', borderRadius: '6px', fontSize: '12px', fontWeight: '700', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: '4px' }}
          >
            <Download size={13} /> Template
          </button>
        </div>

        {/* File Picker */}
        <div style={styles.fieldContainer}>
          <label style={styles.fieldLabel}>Select Excel File (.xlsx / .xls)</label>
          <input 
            type="file" 
            accept=".xlsx, .xls" 
            onChange={handleExcelFileUpload} 
            style={{ ...styles.formInput, padding: '8px 12px' }} 
          />
        </div>

        {/* Parsed Preview Table */}
        {parsedLeads.length > 0 && (
          <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px' }}>
              <span style={{ fontSize: '12px', fontWeight: '700', color: '#166534' }}>
                ✓ {parsedLeads.length} Leads Ready for Import
              </span>
            </div>
            <div style={{ maxHeight: '160px', overflowY: 'auto', border: '1px solid #e2e8f0', borderRadius: '6px' }}>
              <table style={{ ...styles.dataTable, fontSize: '12px' }}>
                <thead>
                  <tr style={{ background: '#f1f5f9' }}>
                    <th style={{ padding: '6px 10px' }}>Name</th>
                    <th style={{ padding: '6px 10px' }}>Mobile</th>
                    <th style={{ padding: '6px 10px' }}>Target Course</th>
                  </tr>
                </thead>
                <tbody>
                  {parsedLeads.slice(0, 10).map((l, i) => (
                    <tr key={i} style={{ borderBottom: '1px solid #f1f5f9' }}>
                      <td style={{ padding: '6px 10px', fontWeight: '600' }}>{l.name}</td>
                      <td style={{ padding: '6px 10px' }}>{l.mobile}</td>
                      <td style={{ padding: '6px 10px' }}>{l.target_course}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {parsedLeads.length > 10 && (
                <div style={{ textAlign: 'center', fontSize: '11px', color: '#64748b', padding: '4px' }}>
                  ...and {parsedLeads.length - 10} more rows
                </div>
              )}
            </div>
          </div>
        )}

        {/* Modal Action Buttons */}
        <div style={styles.formActionDock}>
          <button type="button" onClick={() => setIsBulkModalOpen(false)} style={styles.formCancelBtn}>Cancel</button>
          <button 
            type="button" 
            onClick={handleBulkUploadSubmit} 
            disabled={parsedLeads.length === 0 || uploadingBulk}
            style={{ 
              ...styles.formSaveBtn, 
              background: parsedLeads.length === 0 ? '#94a3b8' : 'linear-gradient(90deg, #10b981 0%, #059669 100%)',
              cursor: parsedLeads.length === 0 ? 'not-allowed' : 'pointer'
            }}
          >
            {uploadingBulk ? 'Uploading...' : `Upload ${parsedLeads.length} Leads`}
          </button>
        </div>

      </div>
    </div>
  </div>
)}

      <style dangerouslySetInnerHTML={{__html: `
        @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
      `}} />
    </div>
  );
}

const styles = {
  topActionBar: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '16px', marginBottom: '20px', flexWrap: 'wrap' },
  tabScrollGroup: { display: 'flex', gap: '8px', overflowX: 'auto', paddingBottom: '4px', maxWidth: '80vw' },
  tabBtn: { display: 'inline-flex', alignItems: 'center', padding: '10px 16px', background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '10px', color: '#64748b', fontSize: '13.5px', fontWeight: '500', cursor: 'pointer', whiteSpace: 'nowrap', transition: 'all 0.2s ease' },
  tabBtnActive: { background: 'linear-gradient(135deg, #459bf2 0%, #1c6ec9 100%)', borderColor: '#459bf2', color: '#ffffff', boxShadow: '0 4px 12px rgba(69, 155, 242, 0.2)' },
  addNewLeadBtn: { background: 'linear-gradient(90deg, #e30504 0%, #a80302 100%)', border: 'none', borderRadius: '12px', color: '#fff', padding: '12px 20px', fontSize: '13px', fontWeight: '700', cursor: 'pointer', letterSpacing: '0.5px', boxShadow: '0 4px 12px rgba(227, 5, 4, 0.2)' },
  filterControlPanel: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '16px', marginBottom: '20px', flexWrap: 'wrap', borderBottom: '1px solid #edf2f7', paddingBottom: '16px' },
  searchWrapper: { position: 'relative', display: 'flex', alignItems: 'center', flex: 1, maxWidth: '340px', width: '100%' },
  searchIcon: { position: 'absolute', left: '14px', color: '#94a3b8' },
  tableSearchInput: { width: '100%', padding: '10px 14px 10px 40px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '10px', color: '#0f172a', fontSize: '14px', outline: 'none' },
  totalIndicator: { fontSize: '15px', fontWeight: '600', color: '#334155' },
  dataTable: { width: '100%', borderCollapse: 'collapse', textAlign: 'left' },
  tableTh: { padding: '14px 16px', borderBottom: '2px solid #edf2f7', color: '#64748b', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.5px', fontWeight: '600' },
  tableTr: { borderBottom: '1px solid #f1f5f9', transition: 'background 0.2s ease' },
  tableTd: { padding: '14px 16px', color: '#475569', fontSize: '13.5px', verticalAlign: 'top' },
  phoneLinkCircle: { width: '24px', height: '24px', borderRadius: '50%', background: '#e0f2fe', color: '#0369a1', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', marginRight: '6px' },
  courseBadge: { background: '#f0fdf4', border: '1px solid #bbf7d0', color: '#166534', padding: '4px 8px', borderRadius: '6px', fontSize: '12px', fontWeight: '500' },
  actIntBtn: { background: '#dcfce7', border: 'none', color: '#15803d', padding: '6px 10px', borderRadius: '6px', fontSize: '12px', fontWeight: '600', cursor: 'pointer' },
  actCallBtn: { background: '#fef3c7', border: 'none', color: '#b45309', padding: '6px 10px', borderRadius: '6px', fontSize: '12px', fontWeight: '600', cursor: 'pointer' },
  actConfBtn: { background: '#dbeafe', border: 'none', color: '#1d4ed8', padding: '6px 10px', borderRadius: '6px', fontSize: '12px', fontWeight: '600', cursor: 'pointer' },
  actNotIntBtn: { background: '#fee2e2', border: 'none', color: '#b91c1c', padding: '6px 10px', borderRadius: '6px', fontSize: '12px', fontWeight: '600', cursor: 'pointer' },
  paginationBar: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '20px' },
  pagBtn: { background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '8px', color: '#475569', padding: '6px 14px', fontSize: '13px', cursor: 'pointer' },
  pagBtnDisabled: { opacity: 0.4, cursor: 'not-allowed' },
  modalBackdrop: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(15, 23, 42, 0.25)', backdropFilter: 'blur(8px)', zIndex: 2000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' },
  modalWrapperCard: { background: '#ffffff', border: '1px solid rgba(255,255,255,0.8)', borderRadius: '20px', width: '100%', maxWidth: '640px', maxHeight: '85vh', padding: '24px', boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.05)', display: 'flex', flexDirection: 'column', boxSizing: 'border-box' },
  modalHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBottom: '14px', borderBottom: '1px solid #e2e8f0' },
  modalCloseX: { background: 'transparent', border: 'none', color: '#94a3b8', cursor: 'pointer' },
  modalScrollBody: { flex: 1, overflowY: 'auto', padding: '16px 4px 4px 4px' },
  modalForm: { display: 'flex', flexDirection: 'column', gap: '16px' },
  formSplitGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px' },
  // strict widths and ellipsis handling parameters
  truncatedText: {
    maxWidth: '140px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },

  courseChip: {
  background: '#dbeafe',
  color: '#1e40af',
  border: '1px solid #bfdbfe',
  borderRadius: '16px',
  padding: '3px 10px',
  fontSize: '11.5px',
  fontWeight: '600',
  display: 'inline-flex',
  alignItems: 'center',
  gap: '4px'
},
chipRemoveBtn: {
  background: 'transparent',
  border: 'none',
  color: '#1e40af',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  padding: 0
},
courseOptionRow: {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  padding: '6px 10px',
  borderRadius: '6px',
  cursor: 'pointer',
  border: '1px solid #e2e8f0',
  transition: 'all 0.15s ease'
},
  actionBtnContainer: {
    display: 'flex',
    gap: '4px',
    alignItems: 'center',
    whiteSpace: 'nowrap'
  },
  tableTh: { padding: '12px 10px', borderBottom: '2px solid #edf2f7', color: '#64748b', fontSize: '11.5px', textTransform: 'uppercase', letterSpacing: '0.5px', fontWeight: '600' },
  tableTd: { padding: '10px', color: '#475569', fontSize: '13px', verticalAlign: 'middle' },
  
  // Downscaled micro-action typography sizes
  actIntBtn: { background: '#dcfce7', border: 'none', color: '#15803d', padding: '4px 8px', borderRadius: '5px', fontSize: '11px', fontWeight: '600', cursor: 'pointer' },
  actCallBtn: { background: '#fef3c7', border: 'none', color: '#b45309', padding: '4px 8px', borderRadius: '5px', fontSize: '11px', fontWeight: '600', cursor: 'pointer' },
  actConfBtn: { background: '#dbeafe', border: 'none', color: '#1d4ed8', padding: '4px 8px', borderRadius: '5px', fontSize: '11px', fontWeight: '600', cursor: 'pointer' },
  actNotIntBtn: { background: '#fee2e2', border: 'none', color: '#b91c1c', padding: '4px 8px', borderRadius: '5px', fontSize: '11px', fontWeight: '600', cursor: 'pointer' },
  fieldContainer: { display: 'flex', flexDirection: 'column', gap: '4px' },
  fieldLabel: { color: '#64748b', fontSize: '11px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px', display: 'flex', alignItems: 'center', gap: '4px' },
  formInput: { width: '100%', padding: '11px 12px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '8px', color: '#0f172a', fontSize: '13.5px', outline: 'none', boxSizing: 'border-box' },
  formSelect: { padding: '11px 12px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '8px', color: '#0f172a', fontSize: '13.5px', outline: 'none' },
  formActionDock: { display: 'flex', justifyContent: 'flex-end', gap: '12px', marginTop: '12px', borderTop: '1px solid #e2e8f0', paddingTop: '14px' },
  formCancelBtn: { background: 'transparent', border: '1px solid #e2e8f0', color: '#64748b', padding: '10px 18px', borderRadius: '8px', cursor: 'pointer' },
  formSaveBtn: { background: 'linear-gradient(90deg, #459bf2 0%, #1c6ec9 100%)', border: 'none', color: '#fff', padding: '10px 18px', borderRadius: '8px', fontWeight: '600', cursor: 'pointer' },
// Locate and replace these properties in your styles object:

formSplitGrid: { 
  display: 'grid', 
  gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr)', // ⚡ Ensures columns never stretch beyond 50%
  gap: '14px' 
},

fieldContainer: { 
  display: 'flex', 
  flexDirection: 'column', 
  gap: '4px',
  minWidth: 0 // ⚡ Allows child inputs/selects to truncate/shrink within the grid cell
},

formSelect: { 
  width: '100%', 
  boxSizing: 'border-box', // ⚡ Prevents padding overflow
  padding: '11px 12px', 
  background: '#f8fafc', 
  border: '1px solid #e2e8f0', 
  borderRadius: '8px', 
  color: '#0f172a', 
  fontSize: '13.5px', 
  outline: 'none',
  textOverflow: 'ellipsis', // ⚡ Safely truncates extra-long course titles
  whiteSpace: 'nowrap',
  overflow: 'hidden'
},
filterDeckCard: {
  background: '#ffffff',
  border: '1px solid #e2e8f0',
  borderRadius: '14px',
  padding: '16px',
  marginBottom: '20px',
  display: 'flex',
  flexDirection: 'column',
  gap: '14px',
  boxShadow: '0 1px 3px rgba(0, 0, 0, 0.02)'
},
filterTopRow: {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: '16px',
  flexWrap: 'wrap'
},
filterBottomRow: {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: '12px',
  flexWrap: 'wrap',
  paddingTop: '12px',
  borderTop: '1px dashed #edf2f7'
},
filterGroupWrapper: {
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  flexWrap: 'wrap'
},
inlineDateBox: {
  display: 'inline-flex',
  alignItems: 'center',
  background: '#f8fafc',
  border: '1px solid #e2e8f0',
  borderRadius: '8px',
  padding: '4px 8px',
  gap: '6px'
},
filterInputBlock: {
  display: 'flex',
  flexDirection: 'column',
  gap: '2px'
},
filterMiniLabel: {
  fontSize: '9.5px',
  fontWeight: '700',
  color: '#94a3b8',
  textTransform: 'uppercase',
  letterSpacing: '0.4px'
},
compactDateInput: {
  border: 'none',
  background: 'transparent',
  color: '#0f172a',
  fontSize: '12px',
  fontWeight: '600',
  outline: 'none',
  cursor: 'pointer'
},
compactCourseSelect: {
  background: '#f8fafc',
  border: '1px solid #e2e8f0',
  borderRadius: '8px',
  padding: '6px 12px',
  color: '#0f172a',
  fontSize: '12.5px',
  fontWeight: '500',
  outline: 'none',
  maxWidth: '240px',
  cursor: 'pointer'
},
metricsBadge: {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-end',
  background: '#f8fafc',
  padding: '4px 12px',
  borderRadius: '8px',
  border: '1px solid #e2e8f0'
},
resetFilterBtn: {
  background: '#fff1f2',
  border: '1px solid #fecaca',
  color: '#b91c1c',
  padding: '6px 10px',
  borderRadius: '6px',
  fontSize: '11px',
  fontWeight: '700',
  cursor: 'pointer',
  height: 'fit-content',
  alignSelf: 'flex-end'
},
exportExcelBtn: {
  background: '#0f172a',
  color: '#ffffff',
  border: 'none',
  borderRadius: '8px',
  padding: '8px 16px',
  fontSize: '12.5px',
  fontWeight: '700',
  cursor: 'pointer',
  display: 'inline-flex',
  alignItems: 'center',
  gap: '6px',
  marginLeft: 'auto',
  boxShadow: '0 2px 4px rgba(15, 23, 42, 0.1)'
}

};